<template>
  <div class="my-tasks p-0">
    <div class="btnSection f_c_b mb-2">
      <div class="class-name-btn f_c_c activitiesBtn" @click.prevent="showContentLesson()">
        محتوای درس
      </div>
      <div class="btnSection categories-btn-section f_c_c">
        <div @click="lessonPlanFunc" class="class-name-btn f_c_c ml-2">
          طرح درس
        </div>
        <div @click="recordFunc" class="class-name-btn f_c_c ml-2">
          ضبط شده ها
        </div>
        <div @click="startClassFunc" class="class-name-btn f_c_c">
          ورود به کلاس
        </div>
      </div>
    </div>
    <div class="calendarBox f_s_b col-12 p-0">
      <div class="calendar col-12 p-0 f_c_c" style="width: 100%; flex: 0 0 100% !important">
        <div class="content f_s_c">
          <div id="activitiesCollapse" class="accordion" role="tablist">
            <!-- <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button
                  block
                  v-b-toggle.accordion-1
                  class="f_c_b w-100"
                  @click.prevent="acordionControll(0)"
                >
                  <div class="text">کلاس ها</div>
                  <div
                    class="activitiesArrow"
                    :class="[isClick == 0 ? 'myup' : 'mydown']"
                  ></div>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body v-if="classList.length">
                  <b-card-text
                    class="f_c_b w-100"
                    v-for="(v, i) in classList"
                    :key="i"
                  >
                    <div class="name className">
                      {{ v.activities.name }}
                    </div>
                    <div class="date f_c_c classDate">
                      <div class="f_c_c ml-2 f-w-w">
                        ساعت شروع
                        <div class="s-e-time mr-2">
                          {{ v.activities.start ? v.activities.start : "-" }}
                        </div>
                      </div>
                      <div class="f_c_c f-w-w">
                        ساعت پایان
                        <div class="s-e-time mr-2">
                          {{ v.activities.end ? v.activities.end : "-" }}
                        </div>
                      </div>
                    </div>
                    <div v-if="classList.length" class="btnSection f_c_c">
                      <b-img
                        v-if="isClickStartRecord && isClickStartRecordId == i"
                        id="categoriesWait"
                        class="image ml-2 mb-2"
                        style="min-width: 60px"
                        :src="require(`@/assets/images/wait.gif`)"
                        fluid
                      ></b-img>
                      <div
                        v-else
                        class="recordBtn f_c_c mb-2"
                        style="min-width: 60px"
                        @click.prevent="recordFunc(v, i)"
                      >
                        ضبط شده ها
                      </div>
                      <b-img
                        v-if="isClickStartClass && isClickStartClassId == i"
                        id="categoriesWait"
                        class="image mb-2"
                        style="min-width: 60px"
                        :src="require(`@/assets/images/wait.gif`)"
                        fluid
                      ></b-img>
                      <a
                        v-else
                        style="min-width: 60px"
                        class="startBtn f_c_c mb-2"
                        target="_blank"
                        href="#"
                        @click.prevent="startClassFunc(v, i)"
                        >ورود به کلاس</a
                      >
                    </div>
                  </b-card-text>
                </b-card-body>
                <b-card-body v-else class="f_c_c w-100">
                  موردی یافت نشد.
                </b-card-body>
              </b-collapse>
            </b-card> -->

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button
                  block
                  v-b-toggle.accordion-2
                  class="f_c_b w-100"
                  @click.prevent="acordionControll(1)"
                >
                  <div class="text">آزمون ها</div>
                  <div class="activitiesArrow" :class="[isClick == 1 ? 'myup' : 'mydown']"></div>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                <b-card-body v-if="examList.length">
                  <b-card-text
                    class="f_c_b w-100 cardFilter"
                    v-for="(v, i) in examList"
                    :key="i"
                    :data-day="v.date.split('-')[2]"
                    :data-month="v.date.split('-')[1]"
                    :data-year="v.date.split('-')[0]"
                  >
                    <div v-if="examList.length" class="name">
                      {{ v.activities.name }}
                    </div>
                    <div v-if="examList.length" class="date f_c_c">
                      <div class="f_c_c ml-2 f-w-w">
                        از
                        <div class="s-e-time mr-2 ml-2">
                          {{ v.activities.start }}
                        </div>
                        <div class="dateText f_c_c">
                          {{ v.date.split("-")[2] }}
                          <div class="month ml-1 mr-1">
                            {{ monthCode("month", v.date.split("-")[1]) }}
                          </div>
                          {{ v.date.split("-")[0] }}
                        </div>
                      </div>
                      <div class="f_c_c f-w-w ml-2">
                        تا
                        <div class="s-e-time mr-2">
                          {{ v.activities.end }}
                        </div>
                      </div>
                      {{
                        new Date(v.activities.endtime_s * 1000).toLocaleDateString("fa-Ir", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      }}
                    </div>
                    <div class="btnSection f_c_c">
                      <div class="startBtn f_c_c" @click.prevent="showExamFunc(v)">
                        آزمون
                      </div>
                      <div class="startBtn f_c_c" @click.prevent="showExamResultFunc(v)">
                        مشاهده نتیجه
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
                <b-card-body v-else class="f_c_c w-100">
                  موردی یافت نشد.
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button
                  block
                  v-b-toggle.accordion-3
                  class="f_c_b w-100"
                  @click.prevent="acordionControll(2)"
                >
                  <div class="text">تکالیف</div>
                  <div class="activitiesArrow" :class="[isClick == 2 ? 'myup' : 'mydown']"></div>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                <b-card-body v-if="taskList.length">
                  <b-card-text
                    class="f_c_b w-100 cardFilter"
                    v-for="(v, i) in taskList"
                    :key="i"
                    :data-day="v.date.split('-')[2]"
                    :data-month="v.date.split('-')[1]"
                    :data-year="v.date.split('-')[0]"
                  >
                    <div v-if="taskList.length" class="name">
                      {{ v.activities.name }}
                    </div>
                    <div v-if="taskList.length" class="date f_c_c">
                      <div class="f_c_c ml-2 f-w-w">
                        ساعت شروع
                        <div class="s-e-time mr-2">
                          {{ v.activities.start }}
                        </div>
                      </div>
                      <div class="f_c_c f-w-w ml-2">
                        ساعت پایان
                        <div class="s-e-time mr-2">
                          {{ v.activities.end }}
                        </div>
                      </div>
                      <div class="dateText f_c_c">
                        {{ v.date.split("-")[2] }}
                        <div class="month ml-1 mr-1">
                          {{ monthCode("month", v.date.split("-")[1]) }}
                        </div>
                        {{ v.date.split("-")[0] }}
                      </div>
                    </div>
                    <div class="btnSection f_c_c">
                      <div class="startBtn f_c_c" @click.prevent="showTaskFunc(v)">
                        مشاهده
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
                <b-card-body v-else class="f_c_c w-100">
                  موردی یافت نشد.
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button
                  block
                  v-b-toggle.accordion-4
                  class="f_c_b w-100"
                  @click.prevent="acordionControll(4)"
                >
                  <div class="text">جلسات جبرانی</div>
                  <div class="activitiesArrow" :class="[isClick == 4 ? 'myup' : 'mydown']"></div>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                <b-card-body v-if="jobraniList.length">
                  <b-card-text
                    class="f_c_b w-100 cardFilter"
                    v-for="(v, i) in jobraniList"
                    :key="i"
                    :data-day="v.date.split('-')[2]"
                    :data-month="v.date.split('-')[1]"
                    :data-year="v.date.split('-')[0]"
                  >
                    <del v-if="v.related_to_past" class="name" style="color: #a6aaab">
                      کلاس جبرانی
                    </del>
                    <div v-else class="name" :class="[v.is_today_session ? 'colorOrange' : '']">
                      {{ v.is_today_session ? "کلاس جبرانی امروز" : "کلاس جبرانی" }}
                    </div>
                    <div v-if="jobraniList.length" class="date f_c_c">
                      <div class="f_c_c ml-2 f-w-w">
                        ساعت شروع
                        <div class="s-e-time mr-2">
                          {{ v.start_time }}
                        </div>
                      </div>
                      <div class="f_c_c f-w-w ml-2">
                        ساعت پایان
                        <div class="s-e-time mr-2">
                          {{ v.end_time }}
                        </div>
                      </div>
                      <div class="dateText f_c_c">
                        {{ v.date.split("-")[2] }}
                        <div class="month ml-1 mr-1">
                          {{ monthCode("month", v.date.split("-")[1]) }}
                        </div>
                        {{ v.date.split("-")[0] }}
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
                <b-card-body v-else class="f_c_c w-100">
                  موردی یافت نشد.
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
      <div class="task-class col-4 p-0 f_c_b d-none">
        <div class="class-name f_c_s">
          <div class="class-name-text">محتوای درس</div>
          <div class="btnSection f_c_sa">
            <div class="class-name-btn f_c_c activitiesBtn" @click.prevent="showContentLesson()">
              مشاهده
            </div>
          </div>
        </div>
        <b-img
          class="lesson-class-icon"
          :src="require(`@/assets/images/my/tasks/categoriesActivities.svg`)"
          fluid
        ></b-img>
      </div>
    </div>
    <b-modal
      id="search-modal"
      title="نتیجه آزمون"
      button-size="sm"
      :hide-footer="footer"
      ref="result-modal"
    >
      <template>
        <div class="f_c_c w-100" style="min-height: 70px">
          {{ showExamResultStatus.msg ? showExamResultStatus.msg : "" }}
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins/mixin";
import { EventBus } from "@/assistant/EventBus";
export default {
  mixins: [mixin],
  name: "LessonActivities",
  data() {
    return {
      isSelectDay: null,
      isData: true,
      isFilterHover: null,
      checked: false,
      selectedDate: "",
      filterLesson: [],
      filterDate: [],
      filterLessonList: [],
      footer: true,
      filtered: false,
      isClickStartClass: false,
      isClickStartRecord: false,
      classList: [],
      taskList: [],
      jobraniList: [],
      examList: [],
      classSelect: {},
      selectLesson: {},
      isClick: 0,
      enterClass: null,
      isClickStartClassId: null,
      isClickStartRecordId: null,
    };
  },
  created() {
    EventBus.$on("filtered", (data) => {
      this.filtered = data;
    });
  },
  computed: {
    ...mapState({
      loginStates: (state) => state.login,
      heightWidthValue: (state) => state.login.heightWidthValue,
      LessonsDays: (state) => state.my.lessonDays,
      lessonActivities: (state) => state.my.lessonActivities,
      startClass: (state) => state.my.startClass,
      lessonSelected: (state) => state.my.lessonSelected,
      ContentData: (state) => state.my.contentData,
      contentLesson: (state) => state.my.contentLesson,
      breadcrumbsPath: (state) => state.my.breadcrumbsPath,
      showExamResultStatus: (state) => state.my.showExamResultStatus,
      publicCoursesReturnStatusData: (state) => state.my.publicCoursesReturnStatusData,
      time: (state) => state.my.time,
    }),
    user() {
      return this.loginStates.user;
    },
  },
  components: {},
  props: { categoriesData: Object, basicData: Object },
  methods: {
    ...mapActions("my", [
      "prevUrlFunction",
      "setActivitiesLinkFunction",
      "recordListFunction",
      "startClassFunction",
      "showContentLessonFunction",
      "setCategoriesContentFunction",
      "setCategoriesBasicDataFunction",
      "showContentLessonDataFunction",
      "returnCategoriesFunction",
      "setBreadcrumbsPathFunction",
      "getTimeFunction",
      "showExamResultFunction",
    ]),
    showContentLesson() {
      this.setCategoriesContentFunction(this.categoriesData.section_id);
      this.setCategoriesBasicDataFunction(this.basicData);
      this.setBreadcrumbsPathFunction({
        parent: "categories",
        paths: [
          this.breadcrumbsPath.paths[0],
          {
            title: "فعالیت درس",
            path: "categories",
          },
          {
            title: "محتوای درس",
            path: "",
          },
        ],
      });
      this.showContentLessonDataFunction({
        v: this.ContentData.v,
        lesson: this.ContentData.lesson,
      });
    },
    acordionControll(i) {
      if (i == this.isClick) {
        this.isClick = null;
      } else {
        this.isClick = i;
      }
    },
    activitiesFilter() {
      let elements = document.querySelectorAll(".card .cardFilter");
      if (this.checked) {
        for (let i = 0; i < elements.length; i++) {
          elements[i].style.display = "flex";
        }
      } else {
        if (this.selectedDate) {
          let day = this.selectedDate.split("/")[2];
          let month = this.selectedDate.split("/")[1];
          let year = this.selectedDate.split("/")[0];
          for (let i = 0; i < elements.length; i++) {
            if (
              elements[i].getAttribute("data-day") == day &&
              elements[i].getAttribute("data-month") == month &&
              elements[i].getAttribute("data-year") == year
            ) {
              elements[i].style.display = "flex";
            } else {
              elements[i].style.display = "none";
            }
          }
          for (let j = 0; j < this.classList.length; j++) {
            if (this.classList[j].date == year + "-" + month + "-" + day) {
              this.classSelect = {
                date: this.classList[j].date,
                activities: this.classList[j].activities,
              };
            }
          }
          setTimeout(() => {
            this.startClassFunction({
              wstoken: this.user.token,
              courseid: parseInt(this.categoriesData.id),
              name: this.classSelect.activities.name,
            });
          }, 500);
        }
      }
      this.$refs["activities-modal"].hide();
    },
    showExamResultFunc(v) {
      this.showExamResultFunction({
        wstoken: this.user.token,
        cm: v.activities.cm,
      });
    },
    showExamFunc(v) {
      let day = parseInt(v.date.split("-")[2]);
      if (this.LessonsDays.weekDigitEn.indexOf(day) > -1) {
        this.setActivitiesLinkFunction({
          id: parseInt(v.activities.id),
          data: v,
          month: this.monthCode("month", parseInt(v.date.split("-")[1])),
        });
        this.$router.push({ name: "exam" });
      } else {
        this.$bvToast.toast("آزمون انتخابی خارج از بازه هفته جاری است.", {
          title: "خطا در زمان ",
          variant: "danger",
          solid: true,
        });
      }
    },
    showTaskFunc(v) {
      this.setActivitiesLinkFunction({
        id: parseInt(v.activities.id),
        data: v,
        month: this.monthCode("month", parseInt(v.date.split("-")[1])),
      });
      this.$router.push({ name: "tasks" });
    },
    startClassFunc() {
      // this.isClickStartClassId = i;
      // this.isClickStartClass = true;
      // this.enterClass = item.activities.id;
      // this.startClassFunction({
      //   wstoken: this.user.token,
      //   courseid: parseInt(item.activities.cm),
      //   name: item.activities.name,
      //   lesson: item.activities,
      // });
      this.isClickStartClassId = 0;
      this.isClickStartClass = true;
      this.enterClass = this.categoriesData.id;
      this.startClassFunction({
        wstoken: this.user.token,
        courseid: parseInt(this.categoriesData.id),
        name: this.categoriesData.name,
        lesson: null,
      });
    },
    recordFunc() {
      this.getTimeFunction({ wstoken: this.user.token });
      this.selectLesson = this.categoriesData;
      this.isClickStartRecord = true;
      this.isClickStartRecordId = 0;
    },
    lessonPlanFunc() {
      this.$router.push({
        name: "lessonPlan",
        params: { lessonName: this.categoriesData.name, lessonId: this.categoriesData.id },
      });
    },

    getWeekSelectDay(n) {
      this.jobraniList = this.categoriesData.list_jobrani_sessions;
      if (n.length) {
        this.isData = true;
        for (let i = 0; i < n.length; i++) {
          for (let j = 0; j < n[i].activities.length; j++) {
            if (n[i].activities[j].mod == "quiz") {
              this.examList.push({
                date: n[i].date,
                activities: n[i].activities[j],
              });
            } else if (n[i].activities[j].mod == "assign") {
              this.taskList.push({
                date: n[i].date,
                activities: n[i].activities[j],
              });
            } else {
              if (n[i].date == this.lessonSelected) {
                this.classSelect = {
                  date: n[i].date,
                  activities: n[i].activities[j],
                };
              }
              if (n[i].activities[j].mod != "offline") {
                this.classList.push({
                  date: n[i].date,
                  activities: n[i].activities[j],
                });
              }
            }
          }
        }
      } else {
        this.isData = false;
      }
    },
  },
  watch: {
    time() {
      if (this.isClickStartRecord) {
        this.isClickStartRecord = true;
        this.returnCategoriesFunction(true);
        this.recordListFunction({
          wstoken: this.user.token,
          courseid: parseInt(this.categoriesData.id),
          lessonActivitiesName: this.categoriesData.name,
        });

        // if (this.publicCoursesReturnStatusData) {
        //   this.isClickStartRecord = true;
        //   this.returnCategoriesFunction(true);
        //   this.recordListFunction({
        //     wstoken: this.user.token,
        //     courseid: parseInt(this.selectLesson.activities.cm),
        //     lessonActivitiesName: this.selectLesson.activities.name,
        //   });
        // } else {
        //   if (this.selectLesson.activities.endtime_s < n[0].time_st) {
        //     this.isClickStartRecord = true;
        //     this.returnCategoriesFunction(true);
        //     this.recordListFunction({
        //       wstoken: this.user.token,
        //       courseid: parseInt(this.selectLesson.activities.cm),
        //       lessonActivitiesName: this.selectLesson.activities.name,
        //     });
        //   } else {
        //     this.isClickStartRecord = false;
        //     this.$bvToast.toast("کلاس هنوز به اتمام نرسیده است.", {
        //       title: "خطا",
        //       variant: "danger",
        //       solid: true,
        //     });
        //   }
        // }
      }
    },
    lessonActivities() {},
    showExamResultStatus(n) {
      if (Object.keys(n).length) {
        this.$refs["result-modal"].show();
      }
    },
    startClass(n) {
      if (this.enterClass && n.length) {
        this.isClickStartClass = false;
        if (n[0].message == "") {
          if (n[0].data.module_type == "bbb") {
            setTimeout(() => {
              window.open(n[0].link, "_blank");
            }, 500);
          } else {
            this.$cookies.remove("BREEZESESSION");
            this.$cookies.set(
              "BREEZESESSION",
              n[0].data.session.BREEZESESSION,
              parseInt(Date.now()) + 180000,
              n[0].data.session.path,
              n[0].data.session.domain,
              true
            );
            setTimeout(() => {
              window.open(n[0].link, "_blank");
            }, 500);
          }
        } else {
          this.$bvToast.toast(n[0].message, {
            title: "خطا در ورود",
            variant: "danger",
            solid: true,
          });
        }
        // if (parseInt(n[0].lesson.id) == parseInt(this.enterClass)) {
        // }
      }
    },
    contentLesson(n) {
      // this.$router.push({ name: "lessonContent" });
    },
  },
  mounted() {
    this.setHeight(this.heightWidthValue);
    this.getWeekSelectDay(this.categoriesData.activities_in_section);
  },
  beforeDestroy: function() {
    this.prevUrlFunction("categories");
  },
};
</script>
<style lang="scss" scoped>
.my-tasks {
  height: 100%;
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 0.2rem 1rem;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .btnSection {
    flex-wrap: wrap;
    .class-name-btn {
      font-size: 0.75rem;
      background-color: #1d9dae !important;
      border: 1px solid #1d9dae;
      border-radius: 10px;
      width: 100px;
      min-height: 36px;
      line-height: 0;
      margin-bottom: 5px;
      color: white;
      cursor: pointer;
      padding: 5px 10px;
      text-align: center;
    }
    .categories-btn-section {
      .class-name-btn {
        background-color: white !important;
        color: #006e7f;
        border: 1px solid #006e7f;
        &:hover {
          background-color: #006e7f !important;
          color: white;
        }
      }
    }
  }
  .calendarBox {
    position: relative;
    padding: 35px 10px 0 10px;
    height: 100%;
    .modalBtn {
      position: absolute;
      z-index: 9;
      padding: 5px;
      width: 100px;
      top: -5px;
      left: 36%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      background-color: white;
      color: #1d9dae;
      border: 1px solid #1d9dae;
      border-radius: 20px;
      &:hover {
        background-color: #1d9dae;
        color: #fff;
      }
      img {
        width: 12px;
      }
    }
    .calendar {
      flex: 0 0 64.333333% !important;
      height: 100%;
      flex-direction: column;
      .content {
        width: 100%;
        height: 100%;
        background-color: #f1fbf8;
        border: 1px solid #1d9dae;
        border-radius: 5px;
        padding: 5px;
        overflow: hidden;
        .accordion {
          width: 100%;
        }
      }
    }
    .task-class {
      position: relative;
      padding: 0 10px;
      height: 100%;
      flex-direction: column;
      .class-name {
        flex-direction: column;
        border: 1px solid #006e7f;
        width: 90%;
        border-radius: 10px;
        line-height: 3;
        font-size: 15px;
        padding-bottom: 5px;
        .class-name-text {
          color: #1d9dae;
        }
        .btnSection {
          width: 100%;
          flex-wrap: wrap;
          .class-name-btn {
            font-size: 0.75rem;
            background-color: #1d9dae !important;
            border: 1px solid #1d9dae;
            border-radius: 10px;
            width: 100px;
            min-height: 36px;
            line-height: 0;
            margin-bottom: 5px;
            color: white;
            cursor: pointer;
            padding: 5px 10px;
            text-align: center;
          }
        }
      }
      .lesson-class-icon {
        width: 150px;
      }
    }
  }
}
@media (max-width: 1000px) {
  .my-tasks {
    .calendarBox {
      flex-direction: column;
      height: fit-content;
      .modalBtn {
        left: 10px;
      }
      .calendar {
        flex: 0 0 100% !important;
        max-width: 100%;
        margin-bottom: 10vh;
        .content {
          height: fit-content;
          margin-bottom: 4vh;
        }
        .contact {
          .contactBtn {
            width: 100%;
          }
        }
        .ticket-section {
          .record,
          .myTicket {
            width: 100%;
          }
        }
      }
      .task-class {
        flex: 0 0 100%;
        max-width: 100%;
        .class-name {
          width: 100%;
          flex-direction: row;
          justify-content: space-between;
          padding-bottom: 0;
          padding: 0 20px;
          .btnSection {
            width: fit-content;
            .class-name-btn {
              margin-bottom: 0;
            }
          }
        }
        .lesson-class-icon {
          display: none;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .my-tasks {
    padding: 0;
    .calendarBox {
      padding: 0;
      .modalBtn {
        left: 10px;
      }
      .calendar {
        justify-content: flex-start;
        .content {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
